const getters = {
    conversations: state => state.conversations,
    messages: state => state.messages,
    selectedConversation: state => state.selectedConversation,
};

export default getters;